import { Dialog, DialogProps } from "@mui/material";

import AppModalContent from "@/common/components/Modals/AppModalContent";
import { ViewVariant } from "@/common/ts/layout";

import GeneralHistoryView, { GeneralHistoryViewProps } from "./GeneralHistoryView";

export interface OwnProps {
  viewProps: GeneralHistoryViewProps;
}

type Props = OwnProps & DialogProps;

export default function GeneralHistoryViewModal({ viewProps, ...dialogProps }: Props) {
  return (
    <Dialog fullWidth maxWidth='lg' {...dialogProps}>
      <AppModalContent>
        <GeneralHistoryView
          onDeleted={() => {
            dialogProps.onClose && dialogProps.onClose({}, "escapeKeyDown");
          }}
          {...viewProps}
          displayProps={{
            viewVariant: ViewVariant.Tab, // TODO: must be Modal
            ...viewProps?.displayProps,
          }}
        />
      </AppModalContent>
    </Dialog>
  );
}
